const translations = {
    "Safely logging you out of your account. Please Wait...": {
      "en": "Safely logging you out of your account. Please Wait...",
      "ar": "تسجيل خروجك بأمان من حسابك. انتظر من فضلك..."
    }
  }
  export default translations